/** Dashboard figures, in full or weighted by each stage's chance of winning. */
export type CrmValueMode = 'weighted' | 'full';

const STORAGE_KEY = 'crm.dashboard.valueMode';

export const stageArr = (
  arrCents: number,
  winProbability: number,
  mode: CrmValueMode
) =>
  mode === 'full' ? arrCents : Math.round((arrCents * winProbability) / 100);

export const readValueMode = (): CrmValueMode => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'full' ? 'full' : 'weighted';
  } catch {
    return 'weighted';
  }
};

export const saveValueMode = (mode: CrmValueMode) => {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Private windows can refuse storage; the toggle still works.
  }
};
